<template>
  <div class="form-lov" @click="handleSelect">
    <x-proxy-form-item
      :showRequired="showRequired"
      :label="widget.label"
      :processTitle="widget.processTitle"
      :validatorRules="validatorRules"
      :validateKey="validateKey"
      :validateInfo="validateInfo"
      :disabled="widget.readOnly">
      <div class="form-lov-content">
        <x-tag-group
          v-if="renderSence === 'edit'"
          :tags="lovArray"
          calcKey="name"
          :tagMarginWidth="3"
        ></x-tag-group>
        <template v-else-if="renderSence === 'read'">
          <template v-for="(item, index) in lovArray">
            <x-tag :key="index" :label="item.name"></x-tag>
          </template>
          <input v-if="lovArray.length === 0" class="cube-input-field cube-input-field--placeholder" readonly value="-">
        </template>
      </div>
      <input 
        v-if="lovArray.length === 0 && renderSence === 'edit' && !widget.readOnly" 
        class="cube-input-field cube-input-field--placeholder" 
        readonly 
        :value="widget.placeholder" 
      />
      <div v-if="widget.lovAssociated" class="associated-btn" @click.stop="openAssociatedForm">
        <x-svg-icon name="x-lib-associated"></x-svg-icon>
        <span class="associated-btn-span">{{ widget.dataSelector.otherFormName }}</span>
      </div>
    </x-proxy-form-item>
    <div class="form-lov-suffix" :class="{ 'full-height': (validateInfo.validate !== 'error' && !widget.lovAssociated) }" v-if="renderSence === 'edit' && !widget.readOnly"  @click.stop="handleClick">
      <x-svg-icon v-if="!this.formValue || !this.formValue.id" name="x-lib-arrow-right"></x-svg-icon>
      <x-svg-icon v-else name="x-lib-clear"></x-svg-icon>
    </div>
  </div>
</template>

<script>
import FormWidgetConfigMixin from '../../../mixins/form-widget.mixin'
import XTagGroup from '../../x-tag-group/x-tag-group'
import XTag from '../../x-tag/x-tag'
import { mapState, mapMutations } from 'vuex'
import { mapAdapter } from '../form-build-action'

export default {
  name: 'FormWidgetLov',
  components: {
    XTagGroup,
    XTag
  },
  mixins: [FormWidgetConfigMixin],
  inject: ['$compRouter'],
  eventbus: {
    mappingAssignment: {
      listener: function(event) {
        try {
          if (this.propKey === event.key) {
            this.handleMappingAssignment(event.value[0] || {})
          }
        } catch (error) {
          console.log(error)
        }
      },
      scope: 'APP',
      customKey: true
    }
  },
  data() {
    return {
      colConfigs: [],
      compPayloadKey: this.$route.query.key,
    }
  },
  computed: {
    ...mapState({
      compPayload: (state) => state.compRouterModule.compPayload
    }),
    lovArray() {
      // return this.formValue && this.formValue.id ? [this.formValue] : []
      return this.formValue && this.formValue.id && this.formValue.name !== undefined && this.formValue.name !== null ? [this.formValue] : []
    },
    formDetailData() {
      return this.compPayload[this.compPayloadKey].formData
    }
  },
  watch: {
    'formValue.id': {
      handler(newVal) {
        const otherFormFieldList = this.isAssociateOtherFormField(this.formConfigList, this.widget)
        if (otherFormFieldList && otherFormFieldList.length > 0) {
          if (newVal) {
            this.getOtherFormDetailByDocumentId({
              documentId: newVal,
              componentId: this.widget.uuid,
              formId: this.widget.dataSelector.otherFormId
            }).then(res => {
              if (res.data && res.data.singleData) {
                this.doOtherFormAssignments(otherFormFieldList, { extra: res.data.singleData})
              } else {
                this.doOtherFormAssignments(otherFormFieldList)
              }
            })
          } else {
            this.doOtherFormAssignments(otherFormFieldList)
          }
        }
      },
      immediate: true
    }
  },
  created() {
    this.initColConfigs()
  },
  methods: {
    ...mapAdapter(['getOtherFormDetailByDocumentId']),
    getCustomKey() {
      return this.propKey
    },
    handleSelect() {
      if (!this.widget.readOnly) {
        this.$compRouter.push(this.$options.name, {
          key: this.propKey,
          widgetConfig: {
            ...this.widget,
            colConfigs: this.colConfigs
          },
          value: this.formValue,
          formId: this.globalData.formId,
          formData: this.$route.query.inTable ? this.formDetailData : this.formData
        })
      }
    },
    handleClear() {
      this.formValue = {}
      const otherFormFieldList = this.isAssociateOtherFormField(this.formConfigList, this.widget)
      if (otherFormFieldList && otherFormFieldList.length > 0) {
        this.doOtherFormAssignments(otherFormFieldList)
      }
    },
    handleClick() {
      if (!this.widget.readOnly) {
        // if (this.lovArray.length > 0) {
        if (this.formValue && this.formValue.id) {
          this.handleClear()
        } else {
          this.handleSelect()
        }
      }
    },
    initColConfigs() {
      if (this.renderSence === 'edit') {
        // 将显示配置到表格
        let colConfigs = [
          {
            uuid: this.widget.dataSelector.otherComponent,
            label: this.widget.dataSelector.otherComponentName,
            columnKey: this.widget.dataSelector.otherComponent,
            componentType: this.widget.dataSelector.otherComponentType
          }
        ]
        if (this.widget.dataSelector.displayComponents) {
          colConfigs = [
            ...this.widget.dataSelector.displayComponents
              .map((item) => {
                const colConfig = {
                  uuid: item.id,
                  label: item.name,
                  columnKey: item.id,
                  ...item
                }
                return colConfig
              })
          ]
        }
        this.colConfigs = colConfigs
      }
    },
    handleMappingAssignment(selectData) {
      if (Array.isArray(this.widget.dataSelector.formAssignments) && selectData.extra) {
        this.widget.dataSelector.formAssignments.forEach((formAssignment) => {
          this.updateLovAssignments(formAssignment, selectData)
        })
      }
    },
    doOtherFormAssignments(otherFormFieldList, selectData) {
      otherFormFieldList
        .map((component) => {
          return {
            otherFormComponent: component.dataSelector.otherComponent,
            otherFormComponentType: component.dataSelector.otherComponentType,
            otherFormChooseOptions: component.dataSelector.componentOtherChooseOptions || [],
            currentFormComponent: component.uuid, // 他表字段组件
            currentFormComponentType: component.componentType // 他表字段组件类型
          }
        })
        .forEach((item) => {
          if (selectData) {
            this.updateLovAssignments(item, selectData)
          } else {
            this.updatePropValue(item.currentFormComponent, null)
          }
        })
    },
    isAssociateOtherFormField(formConfigList, widget) {
      let assOtherFormFiledList = []
      // 判断是否在表格中
      if (widget.isInTable) {
        const currentTable = formConfigList.find(
          (component) =>
            component.componentType === 'FORM_WIDGET_TABLE' &&
            component.componentConfig.uuid === widget.tableUuid
        )
        if (
          currentTable &&
          currentTable.componentConfig.tableColumn &&
          currentTable.componentConfig.tableColumn.length > 0
        ) {
          currentTable.componentConfig.tableColumn.forEach((column) => {
            if (
              column.componentType === 'FORM_OTHER_TABLE_FIELD' &&
              column.dataSelector &&
              column.dataSelector.selectDataComponentId === widget.uuid
            ) {
              column.isInTable = true
              assOtherFormFiledList.push(column)
            }
          })
        }
      } else {
        formConfigList.forEach((component) => {
          if (
            component.componentType === 'FORM_OTHER_TABLE_FIELD' &&
            component.componentConfig.dataSelector &&
            widget.uuid === component.componentConfig.dataSelector.selectDataComponentId
          ) {
            assOtherFormFiledList.push(component.componentConfig)
          }
        })
      }
      if (assOtherFormFiledList.length === 0) {
        assOtherFormFiledList = undefined
      }
      return assOtherFormFiledList
    },
    updateLovAssignments(formAssignment, selectData) {
      // 获取当前表单字段的值, 此处需要从配置中去取，或者更新时存储当前表单组件类型
      const specialComponentTypes = [
        'FORM_WIDGET_LOV',
        'FORM_FILE_UPLOAD',
        'FORM_PEOPLE_SELECT',
        'FORM_DEPARTMENT_SELECT',
        'FORM_ASSOCIATION'
      ]
      const selectComponentTypes = ['FORM_RADIO_INPUT', 'FORM_SELECT_INPUT', 'FORM_CHECKBOX_INPUT']
      // const generalComponentTypes = []

      let textValue = ''
      if (
        formAssignment.otherFormComponentType === formAssignment.currentFormComponentType &&
        !selectComponentTypes.includes(formAssignment.otherFormComponentType)
      ) {
        // 组件类型相等，且不为选择组件
        this.updatePropValue(
          formAssignment.currentFormComponent,
          selectData.extra[formAssignment.otherFormComponent]
        )
      } else if (
        selectComponentTypes.includes(formAssignment.otherFormComponentType) &&
        selectComponentTypes.includes(formAssignment.currentFormComponentType)
      ) {
        // 组件类型都是选择类组件
        // TODO: 此处需要从他表字段配置中取值，相关配置项需要提供给前端
        const otherFormComponentValue = selectData.extra[formAssignment.otherFormComponent]
        const textLabelArray = Array.isArray(otherFormComponentValue)
          ? otherFormComponentValue
            .map((selectItem) => {
              const option = formAssignment.otherFormChooseOptions.find((option) => {
                return option.id === selectItem
              })
              if (option) {
                return option.label
              } else {
                return undefined
              }
            })
            .filter((item) => item)
          : []

        let component
        if (this.widget.isInTable) {
          // 根据uuid获取指定组件
          const tableComponent = this.formConfigList.find((config) => {
            return config.componentConfig.uuid === this.widget.tableUuid
          })
          const tableColumn = tableComponent.componentConfig.tableColumn
          component = tableColumn.find((column) => {
            return column.uuid === formAssignment.currentFormComponent
          })
        } else {
          // 根据uuid获取指定组件
          const config = this.formConfigList.find((config) => {
            return config.componentConfig.uuid === formAssignment.currentFormComponent
          })
          component = config.componentConfig
        }
        if (!component) {
        } else {
          textValue = textLabelArray
            .map((textLabel) => {
              const option = component.chooseOptions.find((option) => {
                return option.label === textLabel
              })
              if (option) {
                return option.id
              } else {
                return undefined
              }
            })
            .filter((optionId) => optionId)
        }
        this.updatePropValue(formAssignment.currentFormComponent, textValue)
      } else {
        // 文本组件赋值
        if (formAssignment.otherFormComponentType === 'FORM_DEPARTMENT_SELECT') {
          const otherFormComponentValue = selectData.extra[formAssignment.otherFormComponent]
          textValue = Array.isArray(otherFormComponentValue)
            ? otherFormComponentValue.map((deptItem) => deptItem.name).toString()
            : ''
        } else if (formAssignment.otherFormComponentType === 'FORM_PEOPLE_SELECT') {
          const otherFormComponentValue = selectData.extra[formAssignment.otherFormComponent]
          textValue = Array.isArray(otherFormComponentValue)
            ? otherFormComponentValue.map((peopleItem) => peopleItem.username).toString()
            : ''
        } else if (formAssignment.otherFormComponentType === 'FORM_DATA_SELECTOR') {
          const otherFormComponentValue = selectData.extra[formAssignment.otherFormComponent]
          textValue = Array.isArray(otherFormComponentValue)
            ? otherFormComponentValue.map((lovItem) => lovItem.name).toString()
            : otherFormComponentValue && otherFormComponentValue.name
        } else if (formAssignment.otherFormComponentType === 'FORM_WIDGET_AREA') {
          const otherFormComponentValue = selectData.extra[formAssignment.otherFormComponent]
          if (otherFormComponentValue) {
            textValue = ((otherFormComponentValue.province && otherFormComponentValue.province.name) || '') +
                ((otherFormComponentValue.city && otherFormComponentValue.city.name) || '') +
                ((otherFormComponentValue.area && otherFormComponentValue.area.name) || '') +
                ((otherFormComponentValue.address && otherFormComponentValue.address.name) || '')
          } else {
            textValue = ''
          }
        } else if (selectComponentTypes.includes(formAssignment.otherFormComponentType)) {
          const otherFormComponentValue = selectData.extra[formAssignment.otherFormComponent]
          textValue = Array.isArray(otherFormComponentValue)
            ? otherFormComponentValue
              .map((selectItem) => {
                const option = formAssignment.otherFormChooseOptions.find((option) => {
                  return option.id === selectItem
                })
                if (option) {
                  return option.label
                } else {
                  return undefined
                }
              })
              .filter((item) => item)
              .toString()
            : ''
        } else {
          textValue = selectData.extra[formAssignment.otherFormComponent]
        }
        this.updatePropValue(formAssignment.currentFormComponent, textValue)
      }
    },
    openAssociatedForm() {
      if (this.formData[this.widget.uuid] && this.formData[this.widget.uuid].id) {
        this.$router.push({
          name: 'associated-form',
          params: {
            formId: this.widget.associationFormId,
            orgId: this.$route.params.orgId
          },
          query: {
            formId: this.widget.associationFormId,
            originFormId: this.$route.query.formId || this.globalData.formId,
            appId: this.$route.query.appId,
            documentId: this.$route.query.documentId,
            originValueName: this.formData[this.widget.uuid] && this.formData[this.widget.uuid].name,
            originValueId: this.formData[this.widget.uuid] && this.formData[this.widget.uuid].id,
            originUuid: this.widget.associationField.originUuid,
            targetUuid: this.widget.associationField.targetUuid,
            tableUuid: this.$route.query.tableUUID,
            isLov: true
          }
        })
      }
    }
  }
}
</script>

<style lang="scss">
.form-lov {
  position: relative;
  display: flex;
  align-items: center;
  background-color: $--app-box-bgColor;
  .x-proxy-form-item {
    // padding-bottom: 0.43rem;
    .x-proxy-form-item-content {
      padding-right: 2.29rem;
    }
    .associated-btn {
      height: 1.71rem;
      // width: 100%;
      margin-left: -1.14rem;
      margin-right: -4.571rem;
      margin-bottom: -9PX;
      margin-top: 9PX;
      display: flex;
      align-items: center;
      padding-left: 0.857rem;
      box-sizing: border-box;
      font-size: 0.86rem;
      color: $--app-notice-color;
      background-color: $--app-info-color;
      .x-svg-icon {
        display: flex;
        align-items: center;
      }
      .associated-btn-span {
        display: inline-block;
        width: 86vw;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }
  }
  .form-lov-content {
    display: flex;
    flex-wrap: wrap;
    // margin-top: -0.285rem;
  }
  .form-lov-suffix {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 3.43rem;
    height: calc(100% - 1.71rem);
    color: $--app-notice-color;
    &.full-height {
      height: 100%;
    }
  }
}
</style>